export default "__VITE_IMAGE_ASSET__09888b6e__";